export const VERIFICATION_PURPOSE = {
  REGISTER_VERIFY: 'REGISTER_VERIFY',
  BIND_EMAIL: 'BIND_EMAIL',
  RESET_PASSWORD: 'RESET_PASSWORD',
};

const ERROR_MAP = {
  en: {
    'email is required': 'Email is required.',
    'invalid email format': 'Please enter a valid email address.',
    'verification too frequent, try again later': 'Sending too frequently. Please try again later.',
    'email already verified': 'This email is already verified.',
    'email not registered': 'If this email is registered, a verification code will be sent.',
    'email already in use': 'This email is already used by another account.',
    'failed to send verification email': 'Failed to send verification email. Please try again.',
    'invalid verification code': 'Incorrect verification code. Please try again.',
    'verification code expired': 'Verification code expired. Please request a new one.',
    'verification failed': 'Verification failed. Please try again.',
    'request failed': 'Operation failed. Please try again later.',
    'login expired': 'Your session has expired. Please sign in again.',
  },
  zh: {
    'email is required': '请输入邮箱地址。',
    'invalid email format': '请输入有效的邮箱地址。',
    'verification too frequent, try again later': '发送过于频繁，请稍后再试。',
    'email already verified': '该邮箱已验证。',
    'email not registered': '若该邮箱已注册，验证码将发送至您的邮箱。',
    'email already in use': '该邮箱已被其他账号使用。',
    'failed to send verification email': '验证码发送失败，请稍后重试。',
    'invalid verification code': '验证码错误，请重新输入。',
    'verification code expired': '验证码已过期，请重新发送。',
    'verification failed': '验证失败，请重试。',
    'request failed': '操作失败，请稍后重试。',
    'login expired': '登录状态已失效，请重新登录。',
  },
};

export function mapVerificationError(message, lang = 'en') {
  if (!message) {
    return lang === 'zh' ? '操作失败，请稍后重试。' : 'Operation failed. Please try again later.';
  }
  const locale = lang === 'zh' ? 'zh' : 'en';
  const normalized = String(message).trim().toLowerCase();
  const entries = ERROR_MAP[locale];
  for (const [key, value] of Object.entries(entries)) {
    if (normalized === key || normalized.includes(key)) {
      return value;
    }
  }
  return message;
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
}
